import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import RateOrderModal from "components/rating/RateOrderModal";

const OrderReviewModalContext = createContext(null);

export function OrderReviewModalProvider({ children }) {
  const [slug, setSlug] = useState(null);

  const openOrderReview = useCallback((orderSlug) => {
    if (orderSlug) setSlug(orderSlug);
  }, []);

  const closeOrderReview = useCallback(() => setSlug(null), []);

  const value = useMemo(
    () => ({
      openOrderReview,
      closeOrderReview,
    }),
    [openOrderReview, closeOrderReview]
  );

  return (
    <OrderReviewModalContext.Provider value={value}>
      {children}
      {slug && (
        <RateOrderModal
          orderSlug={slug}
          open={!!slug}
          onClose={closeOrderReview}
          onSuccess={() => {
            window.dispatchEvent(new CustomEvent("order-reviewed"));
          }}
        />
      )}
    </OrderReviewModalContext.Provider>
  );
}

export function useOrderReviewModal() {
  const ctx = useContext(OrderReviewModalContext);
  if (!ctx) {
    throw new Error(
      "useOrderReviewModal must be used within OrderReviewModalProvider"
    );
  }
  return ctx;
}
